import { Link } from 'react-router-dom';
import { articles } from '@/mocks/comics';

export default function ArticleSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-4">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              漫画资讯
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">最新文章</h2>
            <p className="text-sm text-foreground-500 mt-1">韩漫行业动态、新作推荐与深度分析</p>
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/comic/${article.id}`}
              className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">
                  {article.category}
                </span>
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
